import { NgModule } from '@angular/core';
import { CoreModule } from '../core';
import { HeaderTitleModule } from '../header-title';
import { NotificationBarModule } from '../notification-bar';
import { ToolbarMenuModule } from '../toolbar-menu';
import { HeaderComponent } from './header.component';
import { SharedModule } from '../shared';
import { AnnouncementDialogComponent } from './announcement-dialog.component';
import { AnnouncementsComponent } from './announcements.component';
import { CommonLinksComponent } from './common-links.component';
import { AnnouncementsStorage } from './announcements-storage';
import { CommonLinksStorage } from './common-links-storage';
import { WorkspaceLevelLayoutComponent } from './workspace-level-layout.component';
import { DashboardLevelLayoutComponent } from './dashboard-level-layout.component';
import { WorkspaceDrawerBehaviorResolver } from './workspace-drawer-behavior-resolver';
import { SampleTrackingOptionResolver } from './sample-tracking/sample-tracking-option.resolver';

@NgModule({
    imports: [
        CoreModule,
        SharedModule,
        HeaderTitleModule,
        NotificationBarModule,
        ToolbarMenuModule
    ],
    declarations: [
        HeaderComponent,
        WorkspaceLevelLayoutComponent,
        DashboardLevelLayoutComponent,
        AnnouncementDialogComponent,
        AnnouncementsComponent,
        CommonLinksComponent,
    ],
    providers: [
        AnnouncementsStorage,
        CommonLinksStorage,
        WorkspaceDrawerBehaviorResolver,
        SampleTrackingOptionResolver,
    ],
    exports: [
        AnnouncementsComponent,
        CommonLinksComponent
    ],
    entryComponents: [AnnouncementDialogComponent]
})
export class LayoutModule { }
